import { FC } from 'react';

import FormHelperText, { FormHelperTextProps } from '@mui/material/FormHelperText';

import { capitalizeText } from '../../utils/text';

interface Props extends FormHelperTextProps {
  message?: string | null;
}

export const ErrorMessage: FC<Props> = ({ message, ...otherProps }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <FormHelperText {...otherProps} error={true}>
      {message ? capitalizeText(message) : ''}
    </FormHelperText>
  );
};
